import type { BaseSyntheticEvent } from "react";
import FormWizardFormWrapper from "../../../Forms/FormWizard/FormWizardFormWrapper";
import PageFormWidget from "../../../Forms/FormWizard/PageFormRenderer/PageFormWidget/PageFormWidget";
import { useForm, FormProvider } from "react-hook-form";
import PageFormButtons from "../../../Forms/FormWizard/PageFormRenderer/PageFormButtons/PageFormButtons";
import type { FormWizardData } from "../../../Forms/FormWizard/types";
import "./AutomationSettingsStep.scss";
import SchedulerInput from "../SchedulerInput";

interface AutomationSettingsStepProps {
  /** Injected by `FormRenderer` via `cloneElement` (= accumulated `formData`). */
  defaultValues?: FormWizardData;
  /** Injected by `FormRenderer` via `cloneElement` (= `handleStepSubmit`). */
  onValidate?: (
    stepValues: FormWizardData,
    e?: BaseSyntheticEvent,
    isValid?: boolean
  ) => void;
  isSummary?: boolean;
}

const AutomationSettingsStep: React.FC<AutomationSettingsStepProps> = ({
  defaultValues = undefined,
  onValidate = () => {},
  isSummary = false,
}) => {
  const methods = useForm({
    mode: "all",
    values: defaultValues,
  });
  const { handleSubmit, getValues } = methods;

  return (
    <FormProvider {...methods}>
      <FormWizardFormWrapper
        handleSubmit={handleSubmit}
        onSubmit={onValidate}
        getValues={getValues}
      >
        <PageFormWidget isSummary={isSummary}>
          <div
            className={`automation-settings-step-container`}
            data-testid="scheduling-step-container"
          >
            <SchedulerInput isSummary={isSummary} />
          </div>
        </PageFormWidget>
        {!isSummary && (
          <PageFormButtons data-testid="automation-settings-step-buttons" />
        )}
      </FormWizardFormWrapper>
    </FormProvider>
  );
};

export default AutomationSettingsStep;
